import weekIcon from 'src/public/img/illustration-questions.svg';
import congratulationsIcon from 'src/public/img/illustration-win.svg';

import { ProgramSharedStep, ProgramWeekEnum } from 'src/modules/programs/models/programs';

import { CBTProgramStepProps } from '../../models/cbtProgram';
import { BuildingMotivationStep } from '../stepComponents/BuildingMotivationsStep';
import { GoalsAndMotivationPlanStep } from '../stepComponents/GoalsAndMotivationPlanStep';
import { GoalSettingTipsStep } from '../stepComponents/GoalSettingTipsStep';
import { ProsAndConsStep } from '../stepComponents/ProsAndConsStep';
import { SettingGoalsStep } from '../stepComponents/SettingGoalsStep';
import { WeighingItUpStep } from '../stepComponents/WeighingItUpStep';
import { WhatAreYourGoalsStep } from '../stepComponents/WhatAreYourGoals';
import { WhatDidYouNoticeStep } from '../stepComponents/WhatDidYouNoticeStep';
import { CBTProgramWeekTwoStep } from './weekTwo';

const steps: (ProgramSharedStep | CBTProgramWeekTwoStep)[] = [
    ProgramSharedStep.WellbeingCheckInStep,
    ProgramSharedStep.WellbeingScoreStep,
    ProgramSharedStep.FeedbackStep,
    CBTProgramWeekTwoStep.WhatDidYouNoticeStep,
    CBTProgramWeekTwoStep.SettingGoalsStep,
    CBTProgramWeekTwoStep.GoalSettingTipsStep,
    CBTProgramWeekTwoStep.WhatAreYourGoalsStep,
    CBTProgramWeekTwoStep.BuildingMotivationStep,
    CBTProgramWeekTwoStep.ProsAndConsStep,
    CBTProgramWeekTwoStep.WeighingItUpStep,
    ProgramSharedStep.PlanStep,
    ProgramSharedStep.CongratulationsStep,
];

const stepsProps: CBTProgramStepProps[] = [
    {
        id: CBTProgramWeekTwoStep.WhatDidYouNoticeStep,
        component: WhatDidYouNoticeStep,
        tooltip: 'What did you notice last week?',
        grayBackground: true,
        noButtons: true,
    },
    {
        id: CBTProgramWeekTwoStep.SettingGoalsStep,
        component: SettingGoalsStep,
        tooltip: 'Setting goals',
        flexGrow: false,
    },
    {
        id: CBTProgramWeekTwoStep.GoalSettingTipsStep,
        component: GoalSettingTipsStep,
        tooltip: 'Goal setting tips',
        noButtons: true,
    },
    {
        id: CBTProgramWeekTwoStep.WhatAreYourGoalsStep,
        component: WhatAreYourGoalsStep,
        tooltip: 'What are your goals',
        noButtons: true,
    },
    {
        id: CBTProgramWeekTwoStep.BuildingMotivationStep,
        component: BuildingMotivationStep,
        tooltip: 'Building motivation',
        flexGrow: false,
    },
    {
        id: CBTProgramWeekTwoStep.ProsAndConsStep,
        component: ProsAndConsStep,
        tooltip: 'Pros and cons for your goals',
        grayBackground: true,
        noButtons: true,
    },
    {
        id: ProgramSharedStep.PlanStep,
        component: GoalsAndMotivationPlanStep,
        tooltip: 'Over the next week…',
    },
    {
        id: CBTProgramWeekTwoStep.WeighingItUpStep,
        component: WeighingItUpStep,
        tooltip: 'Weighing it up',
        noButtons: true,
    },
];

const t = (key: string) => `cbt:week-2.data.${key}`;

export const weekTwoData = {
    id: ProgramWeekEnum.WeekTwo,
    weekNumber: 1,
    readableWeekNumber: 2,
    iconUrl: weekIcon,
    congratulationsIconUrl: congratulationsIcon,
    title: t('title'),
    congratulationsSneakPeek: t('congratulationsSneakPeek'),
    feedbackPlaceholder: t('feedbackPlaceholder'),
    greetingModalContent: t('greetingModalContent'),
    steps,
    stepsProps,
};
